import incomeAndExpenditureStorePage from './incomeAndExpenditureStorePage';

export default incomeAndExpenditureStorePage;